import { API_BASE_URL } from '../../config';

function getAdminHeaders() {
  const token = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function fetchJsonOrNull(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    ...options
  });
  if (!res.ok) return null;
  return res.json();
}

export async function fetchSegmentCatalog() {
  const headers = getAdminHeaders();
  const json = await fetchJsonOrNull(`${API_BASE_URL}/api/admin/dashboard/segments/catalog`, { headers });
  return json?.katalog || null;
}

export async function fetchSegmentBuilderPreview(payload) {
  const headers = {
    'Content-Type': 'application/json',
    ...getAdminHeaders()
  };
  const json = await fetchJsonOrNull(`${API_BASE_URL}/api/admin/dashboard/segments/builder-preview`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload || {})
  });
  return json?.onizleme || null;
}

export function varsayilanBuilderPayload() {
  return {
    kip: 'yonlendirmeli',
    pencere: 'default',
    kosullar: [
      { grup: 'profil', alan: 'rutin', islem: 'esittir', deger: 'yogun-calisan' },
      { grup: 'davranis', alan: 'pisirme_orani', islem: 'buyuktur', deger: 20 }
    ]
  };
}
